import { Component } from 'react';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { has } from '~/utils/utils';
import TaxLinks from '~/components/taxLinks/taxLinks';
import BodyParser from '~/components/bodyParser/bodyParser';
import PageWrapper from '~/components/wrappers/pageWrapper';
import Share from '~/components/share/share';
import Stick from '~/components/stick/stick';
import SiteSettings from '~/siteSettings';

const CmvAvia = dynamic(() => import('@cbsi-ctd/cmv_avia').then((mod) => mod.Player), { ssr: false });

/**
 * FeaturedNode
 * @category Component
 * @extends Component
 * @summary Displays the a featured node.
 * @prop {Object} data - The node data.
 * @prop {Object} linkToContent - A a link back to the parent content.
 * @prop {Object} drupalSettings - The drupal settings.
 * @return {Node} React featured node.
 * @summary Display a featured node.
 * @return {Node} React node containing the feature node.
 */

class FeaturedNode extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getDate(date) {
    const formattedDate = new Date(date);

    return `${ formattedDate.getMonth() }/${ formattedDate.getDate() }/${ formattedDate.getFullYear() }`;
  }

  render() {
    const { fileUrl, data, linkToContent, drupalSettings } = this.props;
    const content = {
      ...data.nodeQuery
    };
    const video = content.field_video || content.field_video_mpx_id;

    return (
      <>
        <div className='content'>
          {/* Main Image */}
          {!video &&
            <div className='content__header-img'>
              { linkToContent && content.field_image &&
                <Link legacyBehavior href={ content.path }>
                  <a>
                    <picture>
                      <source media='(max-width: 375px)' srcSet={ content.field_image.sm.url } />
                      <img
                        src={ content.field_image.lg.url }
                        width={ content.field_image.lg.width }
                        height={ content.field_image.lg.height }
                        alt={ content.field_image.alt }
                        className='img-full'
                        loading='lazy'
                      />
                    </picture>
                  </a>
                </Link>
              }
              { !linkToContent && content.field_image &&
                <picture>
                  <source media='(max-width: 375px)' srcSet={ content.field_image.sm.url } />
                  <img
                    src={ content.field_image.lg.url }
                    alt={ content.field_image.alt }
                    width={ content.field_image.lg.width }
                    height={ content.field_image.lg.height }
                    className='img-full'
                    loading='lazy'
                  />
                </picture>
              }
              { !content.field_image &&
                <div className='img-missing'>No Image Available</div>
              }
            </div>
          }
          {/* Main Video */}
          {video && has(content, 'hls_streaming_url') &&
            <div className='content__header-video'>
              <div className='content__header-video-wrap'>
                <Stick>
                  <CmvAvia
                    assetURL={ video.hls_streaming_url }
                    posterUrl={ `${ video.thumbnails?.[0].streamingUrl }?width=720&crop=16:9` }
                    videoReferenceId={ content.field_video_reference_id }
                    duration={ video.duration }
                    mediaContentType='vod'
                    videoTitle={ video.title }
                    autoplay
                    captions={ video.field_video_captions }
                    siteSettings={ SiteSettings }
                    fms={ drupalSettings?.videoSettingsQuery?.enable_fms }
                    adNetwork={ drupalSettings?.videoSettingsQuery?.ad_provider }
                  />
                </Stick>
              </div>
            </div>
          }
          <div className='site-bg'>
            <div className='constrain'>
              <div className='content__body'>
                <div className='content__share content__share--sm'>
                  <Share
                    title={ content.title }
                  />
                </div>
                {/* Title */}
                { linkToContent ?
                  <Link legacyBehavior href={ content.path }>
                    <a className='hidden-link'>
                      <h1 className='content__title-sm'>
                        { content.title }
                      </h1>
                    </a>
                  </Link>
                  :
                  <h1 className='content__title-sm'>
                    { content.title }
                  </h1>
                }
                {/* Category */}
                { content.field_category && content.field_category.path &&
                  <div className='content__category'>
                    <Link legacyBehavior href={ content.field_category.path }>
                      { content.field_category.name }
                    </Link>
                  </div>
                }
                {/* Category (if no url) */}
                { content.field_category && content.field_category.path === undefined &&
                  <div className='content__category'>
                    { content.field_category.name }
                  </div>
                }
                {/* Byline */}
                { content.field_display_date &&
                  <div className='content__byline'>
                    <div className='content__byline-date'>
                      { this.getDate(content.field_display_date) }
                    </div>
                  </div>
                }
                {/* Subhead */}
                { content.field_subhead &&
                  <h2>
                    { content.field_subhead }
                  </h2>
                }
                {/* Body */}
                { content.body &&
                  <div className='content__body-main'>
                    <BodyParser
                      content={ content.body }
                      baseDomain={ fileUrl }
                      drupalSettings={ drupalSettings }
                    />
                  </div>
                }
                <div className='content__spacer'></div>
                <TaxLinks content={ content } />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default PageWrapper(FeaturedNode);